/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Front_Hub_NameInputs */

const en_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store Front Hub Name`)
};

const es_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la tienda central`)
};

const fr_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du hub de la vitrine`)
};

const de_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Storefront-Hubs`)
};

const ja_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントハブ名`)
};

const zh_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`店铺中心名称`)
};

const ar_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم مركز واجهة المتجر`)
};

const id_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Hub Etalase`)
};

const it_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome Hub Vetrina`)
};

const ru_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название центра витрины`)
};

const pt_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da Vitrine Hub`)
};

const ko_store_front_hub_name = /** @type {(inputs: Store_Front_Hub_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 허브 이름`)
};

/**
* | output |
* | --- |
* | "Store Front Hub Name" |
*
* @param {Store_Front_Hub_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const store_front_hub_name = /** @type {((inputs?: Store_Front_Hub_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Front_Hub_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_store_front_hub_name(inputs)
	if (locale === "es") return es_store_front_hub_name(inputs)
	if (locale === "fr") return fr_store_front_hub_name(inputs)
	if (locale === "de") return de_store_front_hub_name(inputs)
	if (locale === "ja") return ja_store_front_hub_name(inputs)
	if (locale === "zh") return zh_store_front_hub_name(inputs)
	if (locale === "ar") return ar_store_front_hub_name(inputs)
	if (locale === "id") return id_store_front_hub_name(inputs)
	if (locale === "it") return it_store_front_hub_name(inputs)
	if (locale === "ru") return ru_store_front_hub_name(inputs)
	if (locale === "pt") return pt_store_front_hub_name(inputs)
	return ko_store_front_hub_name(inputs)
});